export default "__VITE_ASSET__DkKTMYba__"